import { cva, type VariantProps } from 'class-variance-authority';

export { default as Badge } from './Badge.vue';

export const badgeVariants = cva(
  'tw-inline-flex tw-items-center tw-rounded-md tw-border tw-border-secondary-200 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-secondary-600 focus:tw-ring-offset-2 dark:tw-border-secondary-700 dark:focus:tw-ring-secondary-400',
  {
    variants: {
      variant: {
        default:
          'tw-border-transparent tw-bg-secondary-600 tw-text-surface-0 tw-shadow hover:tw-bg-secondary-700 dark:tw-bg-secondary-500 dark:tw-text-surface-0 dark:hover:tw-bg-secondary-600',
        secondary:
          'tw-border-transparent tw-bg-secondary-100 tw-text-secondary-900 hover:tw-bg-secondary-200 dark:tw-bg-secondary-800 dark:tw-text-secondary-50 dark:hover:tw-bg-secondary-700',
        destructive:
          'tw-border-transparent tw-bg-red-500 tw-text-neutral-50 tw-shadow hover:tw-bg-red-500/80 dark:tw-bg-red-900 dark:tw-text-neutral-50 dark:hover:tw-bg-red-900/80',
        outline: 'tw-text-neutral-950 dark:tw-text-neutral-50',
        custom: 'tw-border-transparent',
        // Order status variants (consistent with table StatusRenderer)
        approved:
          'tw-border-0 tw-bg-green-100 tw-text-green-500 tw-px-2 tw-py-1 tw-text-sm tw-font-thin dark:tw-bg-green-900/30 dark:tw-text-green-400',
        rejected:
          'tw-border-0 tw-bg-red-100 tw-text-red-500 tw-px-2 tw-py-1 tw-text-sm tw-font-thin dark:tw-bg-red-900/30 dark:tw-text-red-400',
        draft:
          'tw-border-0 tw-bg-gray-100 tw-text-gray-500 tw-px-2 tw-py-1 tw-text-sm tw-font-thin dark:tw-bg-gray-800 dark:tw-text-gray-400',
        pending:
          'tw-border-0 tw-bg-amber-100 tw-text-amber-500 tw-px-2 tw-py-1 tw-text-sm tw-font-thin dark:tw-bg-amber-900/30 dark:tw-text-amber-400',
        clearing:
          'tw-border-0 tw-bg-purple-100 tw-text-purple-500 tw-px-2 tw-py-1 tw-text-sm tw-font-thin dark:tw-bg-purple-900/30 dark:tw-text-purple-400',
        clarification:
          'tw-border-0 tw-bg-orange-100 tw-text-orange-500 tw-px-2 tw-py-1 tw-text-sm tw-font-thin dark:tw-bg-orange-900/30 dark:tw-text-orange-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
export type BadgeVariant = NonNullable<BadgeVariants['variant']>;
